import React, { useState, useEffect, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import Button from '../../../components/Button';
import Heading from '../../../components/Heading';
import Loader from '../../../components/Loader';
import './PendingJobsLogos.scss';
import { ToastContainer, toast } from 'react-toastify';
import { Tab, Table, TableBody, TableHeader, TableRow } from 'semantic-ui-react';
import InputBox from '../../../components/InputBox';
import ButtonContainer from '../../../components/ButtonContainer';
import FromToDatePicker from '../../../components/FromToDatepicker';
import DatePicker from 'react-datepicker'
import getCompaniesWithPendingLogos from '../../../services/getCompaniesWithPendingLogos';
import syncCompLogosyncCompanyLogo from '../../../services/syncCompLogo';

import moment from "moment";
import user from '../../../store/user';
import Dropdown from '../../../components/Dropdown/Dropdown';

const PendingJobsLogos = (props) => {

	const [loader, setLoader] = useState(false);
	const [adminId, setAdminId] = useState();
	const [adminType, setAdminType] = useState();
	const [data, setData] = useState([])

  	const [filterInputs, setFilterInputs] = useState({
		'fromDate': moment().toDate(),
		'toDate': moment().toDate(),
		'jobTypeFilterValue': 0
		// 'pageNumber': 1
	})

	useEffect(() => {
		async function fetchUserData() {
		  const userDetails = await user.getProfile();
		  const adminIdData = userDetails.id;
		  const adminType = userDetails.adminType;
		  setAdminId(adminIdData);
		  setAdminType(adminType);
		  setTimeout(() => {
			onClickSubmitDate(moment().format("YYYY-MM-DD"));
		  }, 500)
		}
		fetchUserData();
	  }, []);

	const handleDateRangeFilter = (props) =>{
        setFilterInputs((prevState) => ({
            ...prevState,
            "fromDate" : props,
        }))
    }

	const onClickClearDate = () => {
        setLoader(true)
        setFilterInputs((prevState) => ({
            ...prevState,
            ["fromDate"]: null
            // ["toDate"]: null,
            // ["pageNumber"]: 1    // for pagination
        }))
		setData([])
		setLoader(false)
    }

	const onClickSubmitDate = async() => {
		const userDetails = await user.getProfile();
		const adminId = userDetails.id;
		const adminType = userDetails.adminType;
        setLoader(true);
		if(filterInputs.fromDate){
			const fromDateFormat = moment(filterInputs.fromDate).format("YYYY-MM-DD");
			let params = {startDate: fromDateFormat, endDate: fromDateFormat}
			console.log(filterInputs)
			if(filterInputs.jobTypeFilterValue){
				params["jobType"] = filterInputs.jobTypeFilterValue
			}
			if(filterInputs.recruiterTypeFilterValue>0){
				params["companyStatus"] = filterInputs.recruiterTypeFilterValue
			}
			let result = await getCompaniesWithPendingLogos(adminId, params)
			if(result && result.data && result.data.status == "success"){
				const responseData = result.data.data;
				let flattenedData = [];
				
				// Flatten companies with jobs - each job becomes a row
				if(responseData.companiesWithJobs && responseData.companiesWithJobs.length > 0) {
					responseData.companiesWithJobs.forEach(company => {
						if(company.jobs && company.jobs.length > 0) {
							company.jobs.forEach(job => {
								flattenedData.push({
									jobId: job.id,
									jobTitle: job.title,
									companyId: company.id,
									companyName: company.name,
									companyLogo: company.companyLogo,
									hasCompany: true,
									recId: job.recId,
									email: job.email || '',
									companyStatus: job.companyStatus || ''
								});
							});
						}
					});
				}
				
				// Add jobs without company mapping
				if(responseData.jobsWithoutCompany && responseData.jobsWithoutCompany.jobs && responseData.jobsWithoutCompany.jobs.length > 0) {
					responseData.jobsWithoutCompany.jobs.forEach(job => {
						flattenedData.push({
							jobId: job.id,
							jobTitle: job.title,
							companyId: null,
							companyName: '',
							companyLogo: null,
							hasCompany: false,
							recId: job.recId,
							email: job.email || '',
							companyStatus: job.companyStatus
						});
					});
				}
				
				setData(flattenedData);
				console.log("fetched data")
			}
			else{
				setData([])
			}
        } 
		else{
			toast.error("start date must be less than or equal to end date");
		}
		setLoader(false)
    }

	const addNewAction = (id) => {
		window.location.href = `https://admin.iimjobs.com/company/managementCompany/${id}?status=${1}`;
    };

	const handleCompanyJobs = (id) => {
		let url = `/?order=desc&pageNumber=1&pageContent=50&adminId=${adminId}&adminType=${adminType}&companyId=${id}`;
		window.open(url, '_blank').focus();
    };

	const handleMapCompany = (recId) => {
		props.history.push(`/recruiter/recruiter_profile_mgtedit?recid=${recId}`);
    };
    const syncLogoAction = async(centId, imageUrl) => {
        console.log("sync action")
		const res = await syncCompLogosyncCompanyLogo(adminId, {centId, imageUrl})
		if(res && res.data && res.data.status == "success"){
			toast.success("sync success")
			await onClickSubmitDate();
		}
		else{
			toast.error("something went wrong")
		}
    };

	const handleFilterChange = (e) => {
        const name = e.target.name;
        const val = e.target.value;
       	console.log(name, val)
		setFilterInputs((prevState) => ({
            ...prevState,
            [name]: val
        }))
    }

  	return (
		<div>
			<ToastContainer
				position="bottom-left"
				autoClose={5000}
				hideProgressBar
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnVisibilityChange
				draggable={false}
				pauseOnHover
			/>

			<div className="row">
				<Heading text={`Companies without logos (${data.length} records)`} />
			</div>
			<div className="row">
				<ButtonContainer heading= 'Filters:'>
					<li>
						<div className='date-picker'>
							<div className="form-group date">
								<div className="col-sm-6 left valueBox">
									<DatePicker className='datePicker'
										selected={filterInputs.fromDate}
										placeholderText='Select Date'
										selectsStart
										onChange={handleDateRangeFilter}
										dateFormat='dd/MM/yyyy'
										// minDate={moment().subtract(6, 'days').startOf("day").toDate()}
										maxDate={moment().toDate()}
									/>
								</div>
							</div>       
						</div>
							
					</li>
					<li>
						<Dropdown data={[{ name: "Select Job Type", id: 0 }, { name: "Paid", id: 1 }, { name: "Free", id: 2 }]} dropdownChange={handleFilterChange} name='jobTypeFilterValue' />
					</li>
					<li>
						<Dropdown data={[{ name: "Select Recruiter Type", id: 0 }, { name: "Direct", id: 1 }, { name: "Consultant", id: 2 }]} dropdownChange={handleFilterChange} name='recruiterTypeFilterValue' />
					</li>
					<li>
						<Button skin='light' disabled={ !(filterInputs.fromDate) ? true :false} text='Submit' clickButton={onClickSubmitDate} ></Button>
					</li>
					<li>
						<Button skin='light' disabled={false} text='Clear' clickButton={onClickClearDate} ></Button>
					</li>
				</ButtonContainer>
			</div>
			{/* add when seperate filter is required */}
			{/* <div className = "row">
				<ButtonContainer heading= 'Select Job Type:'>
					<li>
						<Dropdown data={[{ name: "Select Job Type", id: 0 }, { name: "Paid", id: 1 }, { name: "Free", id: 2 }]} dropdownChange={handleSalaryDropDownChange} name='jobsFilter' />
					</li>
				</ButtonContainer>
			</div> */}
			 {
				loader ?  
				<div className="loader-container">
					<Loader />
				</div> : 
				<div className='page-row text-center'>
					{data.length != 0 &&
						<Table fixed selectable structured className="pending-logos-table">
							<Table.Header>
								<Table.Row>
									<Table.HeaderCell width={2} >Job Id</Table.HeaderCell>
									<Table.HeaderCell width={4} >Job Title</Table.HeaderCell>
									<Table.HeaderCell width={5}>Email</Table.HeaderCell>
									<Table.HeaderCell width={2}>Recruiter Type</Table.HeaderCell>
									<Table.HeaderCell width={5} >Company Name</Table.HeaderCell>
									<Table.HeaderCell width={5} >Logo</Table.HeaderCell>
									<Table.HeaderCell width={10} >Action</Table.HeaderCell>
								</Table.Row>
							</Table.Header>
							<Table.Body>
								{loader ? (
									<div className="loader-container">
										<Loader />
									</div>
								) : (
									data.map((item, index) => {
									return (
										<Table.Row key={`${item.jobId}-${index}`}>
											<Table.Cell className="not-capitalized">{item.jobId}</Table.Cell>
											<Table.Cell className="not-capitalized">{item.jobTitle}</Table.Cell>
											<Table.Cell className="not-capitalized">{item.email}</Table.Cell>
											<Table.Cell className="not-capitalized">{item.companyStatus == 1 ? "Direct" : "Consultant"}</Table.Cell>
											<Table.Cell className="not-capitalized">
												{item.companyName}
												{!item.hasCompany && <span style={{color: 'red', marginLeft: '5px'}}>(No Company)</span>}
											</Table.Cell>
											<Table.Cell className="not-capitalized">
												{item.companyLogo &&
													<>
														<img src={item.companyLogo} className = "ambitionBoxLogoImg"/>
														<Button className="syncLogoBtn" skin="dark" text="Set as company logo" clickButton={()=> syncLogoAction(item.companyId, item.companyLogo)} style={{}}/>
													</>
												}
											</Table.Cell>
											<Table.Cell className="not-capitalized">
												{item.hasCompany ? (
													<>
														<Button className="addNewLogo" skin="dark" text="Upload new logo" clickButton={() => addNewAction(item.companyId)} />
														<Button className="editLogo" skin="dark" text="Edit logo" clickButton={() => addNewAction(item.companyId)} />
														<Button className="companyJobs" skin="dark" text="See Company jobs" clickButton={() => handleCompanyJobs(item.companyId)} />
													</>
												) : (
													<>
														<Button className="mapCompanyBtn" skin="dark" text="Map company" clickButton={() => handleMapCompany(item.recId)} />
													</>
												)}
											</Table.Cell>
										</Table.Row>
									)
								})
								)
		
								}
							</Table.Body>
					 </Table>
					}
				</div>
			}
		</div>
  );
};

export default withRouter(PendingJobsLogos);
